export default __webpack_public_path__ + "static/logo-3558f6e23c0995ea5c99c89ec8f206d2.png";